import { getFixedT } from 'i18next';
import * as Yup from 'yup';

export function mobileRequired() {
    const t = getFixedT(null, 'validation');
    return Yup.string()
        .nullable()
        .typeError(t<string>('phoneNumber.required'))
        .required(t<string>('phoneNumber.required'))
        .test((val, ctx) => {
            if (!isValidMobileNumber(val)) {
                return ctx.createError({ message: t<string>('phoneNumber.invalid') });
            }
            return true;
        });
}

export function isValidMobileNumber(number: string) {
    return parseFinnishMobileNumberParts(number).isValid;
}

const FI_MOBILENUMBER_RE = /^(((\+?|0|00)358)|0?)(?<operator>(4320|4321|4322|4324|4325|4326|4542|4543|4544|4545|4547|4549|4550|4552|4554|4555|4556|4570|4572|4573|4574|4575|4576|4577|4578|4579|4941|4942|4944|4946|435|436|437|438|439|450|451|452|453|456|457|458|40|41|42|44|46|50))(?<subscriber>(\d{4,8}))$/;

export function parseFinnishMobileNumberParts(number:string) {
    const rest = number.replace(/[^\d+]/g, '');
    let operator;
    let subscriber;
    let country;
    let isValid = false;
    const m = FI_MOBILENUMBER_RE.exec(rest);
    if (m) {
        country = '+358';
        operator = `0${m.groups?.operator}`;
        subscriber = `${m.groups?.subscriber}`;
        isValid = true;
    } else {
        operator = `0${rest.slice(0, 2)}`;
        subscriber = rest.slice(2);
    }
    return { country, operator, subscriber, isValid };
}
